import { useLazyQuery, useMutation } from '@apollo/client';
import { Box } from '@material-ui/core';
import { TextErr } from 'component/customize_style_component/styled_title';
import CustomizeLayoutQuiz from 'component/layout_quiz/layout_quiz';
import { useAuth } from 'contexts/AuthContext';
import { CREATE_ANSWER, ValueType } from 'graph_ql/getQuiz/mutation';
import { GET_QUESTION_DATA, GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { GET_USER_BY_USERNAME } from 'graph_ql/users/queries';
import { valuesIn } from 'lodash';
import _isEqual from 'lodash/isEqual';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EQuizId, quizContextType } from 'types/quiz';
import { useGetGender } from '../../../hooks/useGetGender';
import { PATH } from '../../../routes/constant';
import { EValueAnswers } from '../style_quiz/style_quiz';
import ColorItem from './color_quiz_item';
import { useStyles } from './style';

export const mergeQuestionColorQuiz = (arrQuestions, arrAnswers) => {
    return arrQuestions.map((question) => {
        const temp = arrAnswers.find((answer) => answer?.questionId === question?.id);
        if (question?.id === temp?.questionId) {
            question.reaction = temp?.value;
            question.listColorsItems = temp?.questionDatas[0] ? temp?.questionDatas[0]?.descriptions : [];
            question.questionDataId = temp?.questionDataIds?.length ? temp?.questionDataIds[0] : '';
        } else question.reaction = '';
        return { ...question };
    });
};

export interface IColorsQuizProps {}

export default function ColorsQuiz(props: IColorsQuizProps) {
    const { userName } = useParams<{ userName: string }>();
    const { currentUser } = useAuth();
    const history = useHistory();
    const gender = useGetGender(Boolean(userName));
    const location: any = useLocation();
    const classes = useStyles();
    const [error, setError] = useState('');
    const [requiredQuestion, setRequiredQuestion] = useState(true);
    const [swiperInstance, setSwiperInstance] = useState<SwiperCore | undefined>();
    const [listQuestionColor, setListQuestionColor] = useState<any[]>([]);
    const [currentSlideIndex, setCurrentSlideRealIndex] = useState(0);
    const [listAnswerColor, setListAnswerColor] = useState<any[]>([]);
    const [savedAnswers, setSavedAnswers] = useState<any[]>([]);
    const [user, setUser] = useState<any>(null);
    const [showButton, setShowButton] = useState<Boolean>();
    const [quizData, setQuizData] = useState<any>(null);
    const [pendingSaveApi, setPendingSaveApi] = useState(0);
    const [pendingApiLoading, setPendingApiLoading] = useState(false);

    const colorIdSelected = useMemo(() => {
        return location?.state?.colorId;
    }, [location?.state?.colorId]);

    const [getUserByUserName, { loading: userLoading }] = useLazyQuery(GET_USER_BY_USERNAME, {
        onCompleted(data) {
            setUser(data.getUserByUserName);
            getColorQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.COLOR_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.COLOR_QUIZ,
                        userId: data.getUserByUserName?.id,
                    },
                },
            });
        },
    });

    const [getCurentQuestionColor, { loading: loadingQuizColor }] = useLazyQuery(GET_QUESTION_DATA, {
        onCompleted(data) {
            const list = listQuestionColor.map((item) => {
                if (_isEqual(item.questionDataSubject, data.getQuestionData.data[0].subject)) {
                    item.listColorsItems = data.getQuestionData.data[0].descriptions;
                    item.displayOrder = data.getQuestionData.data[0].displayOrder;
                    item.questionSubject = data.getQuestionData.data[0].subject;
                    item.questionDataId = data.getQuestionData.data[0].id;
                }
                return { ...item };
            });
            setListQuestionColor(list);
        },
    });

    useEffect(() => {
        if (listQuestionColor.length) {
            if (colorIdSelected) {
                const colorLocation = listQuestionColor.find((item) => item.id === colorIdSelected);
                if (colorLocation) {
                    getCurentQuestionColor({
                        variables: {
                            input: {
                                subject: colorLocation?.questionDataSubject,
                                paging: { page: 0, size: 0 },
                                enabled: true,
                            },
                        },
                    });
                }
            } else {
                let firstColorQuiz = listQuestionColor[0];
                if (firstColorQuiz?.questionDataSubject && !firstColorQuiz?.listColorsItems.length) {
                    getCurentQuestionColor({
                        variables: {
                            input: {
                                subject: firstColorQuiz?.questionDataSubject,
                                paging: { page: 0, size: 0 },
                                enabled: true,
                            },
                        },
                    });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [colorIdSelected, listQuestionColor]);
    useEffect(() => {
        if (listQuestionColor?.length && location) {
            if (location.pathname === PATH.COLOR_QUIZ) {
                setShowButton(true);
            } else {
                if (
                    listQuestionColor[currentSlideIndex].value &&
                    listQuestionColor.filter((item) => !item?.reaction).length === 0
                )
                    setShowButton(true);
                else setShowButton(false);
            }
        }
    }, [currentSlideIndex, listQuestionColor, location, location.pathname]);

    const isQuizFullyAnswered = useMemo(() => {
        return location.pathname.includes(PATH.MY_STYLE_PREFERENCES);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listQuestionColor]);

    const createAnswer = (input: {
        questionId: String;
        questionSubject: String;
        contextType: String;
        contextId: String;
        value: any;
        valueType: String;
        isSkipped?: boolean;
        id?: string;
        questionDataIds: string[];
    }) => {
        const variables = {
            input,
        };
        answerMutation({ variables });
    };
    const [answerMutation] = useMutation(CREATE_ANSWER, {
        async onCompleted(response) {
            setPendingSaveApi((prevValue) => prevValue - 1);
            setSavedAnswers([...savedAnswers, { ...response?.createAnswer }]);
        },
        onError(error) {
            console.log('Create Failed: ', error);
        },
    });

    const [getColorQuizResponse, { loading: loadingQuiz }] = useLazyQuery(GET_QUIZ_RESPONSE, {
        onCompleted(data) {
            setRequiredQuestion(data.getQuizResponse?.questionsInfo[0]?.required);
            const listAnswers = valuesIn(data.getQuizResponse?.answers);
            const listQuestions = valuesIn(data.getQuizResponse?.questions);
            setListAnswerColor(listAnswers);
            setQuizData(data.getQuizResponse);
            const arrColorOptions: any[] = listQuestions.map((item) => {
                return {
                    listColorsItems: [],
                    reaction: '',
                    displayOrder: 0,
                    value: item.title,
                    ...item,
                };
            });
            setListQuestionColor(mergeQuestionColorQuiz(arrColorOptions, listAnswers));
        },
    });

    const handleClickAnswer = useCallback(() => {
        if (Boolean(!userName)) {
            getColorQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.COLOR_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.COLOR_QUIZ,
                        userId: currentUser?.uid,
                    },
                },
            });
            location.pathname === PATH.COLOR_QUIZ
                ? history.push(PATH.PROFILE)
                : history.push(`${PATH.QUIZ_MANAGER}/?signup=${Date.now()}`);
        }
    }, [userName, location?.pathname, history, currentUser?.uid, getColorQuizResponse]);

    useEffect(() => {
        if (pendingApiLoading && !pendingSaveApi) {
            handleClickAnswer();
        }
    }, [pendingApiLoading, pendingSaveApi, handleClickAnswer]);

    useEffect(() => {
        if (userName) {
            getUserByUserName({
                variables: {
                    input: {
                        userName,
                    },
                },
            });
        }
    }, [userName, getUserByUserName]);

    useEffect(() => {
        if (user && Boolean(userName)) {
            getColorQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.COLOR_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.COLOR_QUIZ,
                        userId: user?.id,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, gender, userName]);

    useEffect(() => {
        if (currentUser && Boolean(!userName)) {
            getColorQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.COLOR_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.COLOR_QUIZ,
                        userId: currentUser.uid,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser.uid, userName]);

    useEffect(() => {
        if (!listQuestionColor?.filter((color) => !color?.reaction).length) setError('');
    }, [listQuestionColor]);

    useEffect(() => {
        // Check allow nextSlide
        if (
            location.pathname === PATH.QUIZ_MANAGER &&
            swiperInstance &&
            listQuestionColor.length > 0 &&
            !listQuestionColor[currentSlideIndex].reaction
        ) {
            swiperInstance.allowSlideNext = false;
        } else {
            if (swiperInstance) {
                swiperInstance.allowSlideNext = true;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listQuestionColor, swiperInstance, currentSlideIndex]);

    const input = {
        contextId: EQuizId.COLOR_QUIZ,
        contextType: quizContextType,
        valueType: ValueType.String,
        value: '',
    };
    const processNextStyle = (slide, value) => {
        const currentColor = listQuestionColor.find((item) => item.id === slide.id);
        let answerColorExist: any = listAnswerColor.find((item) => item?.questionId === slide.id);
        if (!answerColorExist) {
            answerColorExist = savedAnswers.find((item) => item?.questionId === slide.id);
        }
        setListQuestionColor(
            listQuestionColor.map((item) => {
                if (currentColor.id === item.id) item.reaction = value;
                return { ...item };
            }),
        );

        if (answerColorExist) {
            createAnswer({
                ...input,
                id: answerColorExist.id,
                questionId: slide.id,
                questionSubject: slide?.questionDataSubject,
                value: value,
                questionDataIds: [slide?.questionDataId],
            });
        } else {
            createAnswer({
                ...input,
                questionId: slide.id,
                questionSubject: slide?.questionDataSubject,
                value: value,
                questionDataIds: [slide?.questionDataId],
            });
        }
        setPendingSaveApi((prevValue) => prevValue + 1);
        setTimeout(() => {
            if (swiperInstance && currentSlideIndex !== listQuestionColor.length - 1) {
                try {
                    swiperInstance.allowSlideNext = true;
                    swiperInstance?.slideNext();
                } catch (error) {
                    console.debug(error);
                }
            }
        }, 50);
    };

    // used for next enhancement

    useEffect(() => {
        if (listQuestionColor?.length && swiperInstance) {
            if (userName) {
                if (colorIdSelected) {
                    const indexSelected = listQuestionColor.findIndex((color) => color.id === colorIdSelected);
                    if (indexSelected >= 0) {
                        swiperInstance.slideTo(indexSelected);
                    } else swiperInstance.slideTo(0);
                } else if (listQuestionColor.filter((item) => !item.reaction).length > 0) {
                    const index = listQuestionColor.findIndex((item) => !item.reaction);
                    swiperInstance.slideTo(index);
                } else {
                    swiperInstance.slideTo(0);
                }
            }
        }
    }, [userName, swiperInstance, colorIdSelected, listQuestionColor]);

    const renderColorQuiz = (consumer, slide, index) => {
        return (
            <ColorItem
                handleLike={() => (consumer ? null : processNextStyle(slide, EValueAnswers.LIKE))}
                handlDislike={() => (consumer ? null : processNextStyle(slide, EValueAnswers.DISLIKE))}
                title={slide.title}
                listColor={slide?.listColorsItems || []}
                reaction={slide?.reaction}
                loadingAnswer={false}
                swiperInstance={swiperInstance}
                loadingQuiz={index === currentSlideIndex && loadingQuizColor}
                index={index}
            />
        );
    };
    const handleChangeSlide = (e) => {
        setCurrentSlideRealIndex(e.realIndex);
        let currentQuizColor = listQuestionColor[e.realIndex];
        if (currentQuizColor?.questionDataSubject && !currentQuizColor?.listColorsItems.length)
            getCurentQuestionColor({
                variables: {
                    input: {
                        subject: currentQuizColor?.questionDataSubject,
                        paging: { page: 0, size: 0 },
                        enabled: true,
                    },
                },
            });
    };

    return (
        <CustomizeLayoutQuiz
            quizId={EQuizId.COLOR_QUIZ}
            title={Boolean(!userName) ? quizData?.subTitle : ''}
            titlePage={quizData?.title}
            handleAnswer={() => setPendingApiLoading(true)}
            isUpdate={location.pathname.includes(PATH.MY_STYLE_PREFERENCES)}
            isDisplayContent={Boolean(!userName)}
            hideBottomNav={location.pathname === PATH.QUIZ_MANAGER}
            requiredQuestion={requiredQuestion || true}
            isHiddenAction={!showButton || location.pathname.includes(PATH.MY_STYLE_PREFERENCES)}
            submitButtonCustomText={isQuizFullyAnswered ? 'Done' : ''}
            loading={pendingApiLoading}
            containerLoading={loadingQuiz || userLoading}
        >
            <Box textAlign={'center'} width={'100%'} height={'100%'} id="swiper-wrapper">
                <Box textAlign={'center'} width={'100%'} height={`100%`} pt={2}>
                    <Swiper
                        direction="horizontal"
                        onSwiper={setSwiperInstance}
                        onSlideChange={handleChangeSlide}
                        slidesPerView={1.2}
                        centeredSlides={true}
                        spaceBetween={10}
                        className={classes.fitContent}
                        mousewheel
                    >
                        {listQuestionColor?.map((slide, index) => {
                            return <SwiperSlide key={index}>{renderColorQuiz(userName, slide, index)}</SwiperSlide>;
                        })}
                    </Swiper>
                    {error && <TextErr>{error}</TextErr>}
                </Box>
            </Box>
        </CustomizeLayoutQuiz>
    );
}
